import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import { Font, FontWeight } from '../../utils/fonts';

const animation = keyframes`
    0% {
        transform: translateX(-50%);
    }
    99.99% {
        transform: translateX(0%);
    }
    100% {
        transform: translateX(-50%);
    }
`;

const transitTime = 17;

class Ticker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            duration: 0,
        };
        this.line = React.createRef();
    }

    componentDidMount() {
        const { clientWidth } = document.documentElement;
        const { offsetWidth } = this.line.current;
        const duration = Math.floor((offsetWidth * transitTime) / clientWidth);
        this.setState({ duration });
    }

    componentWillUnmount() {
        this.line = null;
    }

    render() {
        const { duration } = this.state;
        const { className, words = [] } = this.props;

        return (
            <Root className={className}>
                <ScrollingBlock duration={duration}>
                    <TagWrapper nowrap ref={this.line}>
                        {
                            words.map((word, index) => (
                                <Tag key={index.toString()} nowrap>
                                    {word}
                                </Tag>
                            ))
                        }
                    </TagWrapper>
                    <TagWrapper>
                        {
                            words.map((word, index) => (
                                <Tag key={index.toString()} nowrap>
                                    {word}
                                </Tag>
                            ))
                        }
                    </TagWrapper>
                </ScrollingBlock>
            </Root>
        );
    }
}

const Root = styled.div`
    width: 100%;
    display: flex;
    align-items: center;

    ${Font.PRIMARY};
    ${FontWeight.REGULAR};

    overflow-x: hidden;

    -webkit-tap-highlight-color: rgba(0,0,0,0);
    user-select: none;
`;

const ScrollingBlock = styled.div`
    display: flex;

    animation-name: ${animation};
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-duration: ${({ duration }) => `${duration}s`};

    /* transform: translateX(-50%); */

    /* ${mediaWidth.m} {
        animation: ${animation} 25s linear infinite;
    }

    ${mediaWidth.l} {
        animation: ${animation} 35s linear infinite;
    }

    ${mediaWidth.xl} {
        animation: ${animation} 40s linear infinite;
    } */
`;

const TagWrapper = styled.div`
    display: flex;
`;

const Tag = styled.span`
    white-space: pre;
    font-size: 14px;
    line-height: 24px;
    color: #0032A0;

    margin-right: 32px;

    ${mediaWidth.m} {
        font-size: 16px;
        line-height: 24px;
    }

    ${mediaWidth.l} {
        font-size: 20px;
        line-height: 28px;
    }

    ${mediaWidth.xl} {
        font-size: 24px;
        line-height: 32px;

        margin-right: 40px;
    }
`;

export default Ticker;
